import React, { useEffect, useState } from "react";
import { Row, Col, Modal } from "antd";
import { CodeSandboxOutlined, WarningOutlined } from "@ant-design/icons";
import data from "../../../../constants/retailPos.json";
import userIcon from "../../../../assets/images/userId.svg";
import POSLogo from "../../../../assets/images/NewLogoCW.svg";
import sideMenu from "../../../../assets/images/side-menu.svg";
import LockIcon from "../../../../assets/images/lock-icon.svg";
import Online from "../../../../assets/images/green.svg";
import Ofline from "../../../../assets/images/red.svg";
import useAuthStore from "../../../../stores/useAuthStore";

const SMHeader = ({
  setTillLink,
  setProductSearchInput,
  themeJSON,
  showSaleType,
  selectedSaleType,
  setIsSaleTypeFlag,
  cart,
  formattedDateTime,
  posConfig,
  setShowCustomMix,
  isOnline,
  setIsLocked,
  userData,
  errorMessage,
}) => {
  const tenantLogoUrl = userData?.CW360_V2_UI?.appTheme?.tenant_logo;
  const [clientLogoFailed, setClientLogoFailed] = useState(false);

  useEffect(() => {
    setClientLogoFailed(false);
  }, [tenantLogoUrl]);

  return (
    <Row
      style={{
        padding: "0.4% 0.5%",
        height: "9vh",
        alignItems: "center",
        fontSize: "1vw",
        width: "100%",
      }}
    >
      <Col
        onClick={() => {
          setTillLink(true);
          setProductSearchInput("");
        }}
        style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
        span={1.2}
      >
        <img src={sideMenu} style={{ paddingLeft: "0.5rem", height: "2vw" }} />
      </Col>
      <Col span={4} style={{ display: "flex", alignItems: "center" }}>
        <img src={themeJSON.logoURL || POSLogo} style={{ height: "2.5vw", paddingLeft: "0.4vw" }} />
        {posConfig?.displayCompanyLogo === "Y" && tenantLogoUrl && !clientLogoFailed && (
          <img
            src={tenantLogoUrl}
            alt="Client Logo"
            style={{ height: "3.5vw", paddingLeft: "0.6vw" }}
            onError={() => setClientLogoFailed(true)}
          />
        )}
      </Col>
      <Col
        span={3}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {showSaleType === true ? (
          <span
            style={{
              display: "flex",
              alignItems: "center",
              color: "#0F0718",
              fontFamily: "Inter",
              fontWeight: 500,
              fontSize: "13px",
              paddingLeft: "1vw",
              cursor: "pointer",
            }}
            onClick={() => {
              if (cart.layAway !== "Y") {
                setProductSearchInput("");
                setIsSaleTypeFlag(true);
              }
            }}
          >
            {selectedSaleType}
          </span>
        ) : (
          ""
        )}
      </Col>
      <Col span={2} />
      <Col
        span={4}
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <span
          style={{
            fontFamily: "Inter",
            fontWeight: 500,
            fontSize: "clamp(10px, 1vw, 16px)",
            color: themeJSON.dateTimeTextColor || "#929098",
          }}
        >
          {" "}
          {formattedDateTime}
        </span>
      </Col>
      <Col
        span={2}
        style={{
          textAlign: "center",
          color: themeJSON.orderNoTextColor || "#0F0718",
          fontFamily: "Inter",
          fontWeight: 500,
          fontSize: "1.1em",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={() => {
          // let filtredDocument = documentTypes?.filter((element) => element.type !== selectedDocumentType && element.isVisible);
          // if (cart?.docType !== "Advance" && filtredDocument.length > 0) {
          //   setShowDocumentPopup(true);
          // }
        }}
      >
        {posConfig?.enableProductGrouping === "Y" && (
          <CodeSandboxOutlined
            style={{ fontSize: "18px", cursor: "pointer" }}
            onClick={() => {
              // BUG-2020: cart edit is opt-in per till via the Till Template flag "Allow Pre
              // Order Update" (posConfig.allowPreOrderUpdate) -- unset/"N" reproduces the
              // original blanket edit-lock; "Y" allows it (gated by the advance-payment
              // floor at processing time instead, see advanceOrderValidation.js).
              if (cart?.preOrder === "Y" && posConfig?.allowPreOrderUpdate !== "Y") {
                Modal.confirm({
                  title: <div style={{ fontWeight: "500", fontSize: "1.2em", color: "#0F0718" }}>Cart Editing Restricted</div>,
                  content: (
                    <div style={{ fontSize: "14px", color: "#0F0718", marginTop: "8px" }}>
                      <p style={{ marginBottom: 0, color: "#0F0718", fontSize: "1em" }}>
                        This is a pre-order with advance payment. Cart items cannot be modified at this stage. Please proceed to complete the transaction.
                      </p>
                    </div>
                  ),
                  icon: <WarningOutlined />,
                  okText: "Ok",
                  cancelButtonProps: { style: { display: "none" } },
                  autoFocusButton: null,
                  modalRender: (node) => <div className="custom-confirm-modal-wrapper">{node}</div>,

                  onOk() {
                    const productSearchInput = document.getElementById("sm-product-search");
                    if (productSearchInput) {
                      setTimeout(() => {
                        productSearchInput.focus();
                      }, 300);
                    }
                  },
                });

                return;
              }
              setShowCustomMix(true);
              localStorage.setItem("customMix", "CM");
              setProductSearchInput("");
              // localStorage.setItem("productSegment", "CB");
            }}
          />
          // <img
          //   src={GroupItemImg}
          //   style={{ height: "6.5vh", width: "4vw", cursor: "pointer" }}
          //   onClick={() => {
          //     setShowCustomMix(true);
          //     localStorage.setItem("customMix", "CM");
          //     // localStorage.setItem("productSegment", "CB");
          //   }}
          // />
        )}
      </Col>
      <Col
        span={8}
        style={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          minWidth: 0,
        }}
      >
        {/* <img
          src={NotesImage}
          onClick={() => {
            setNotesPopup(true);
            if (cart.description && cart.description.trim() !== "") {
              setNotesValue(cart.description);
            }
            setIsInputFocused(true);
          }}
          style={{
            fontSize: "1.5vw",
            cursor: "pointer",
            height: "2.4vh",
            marginRight: "0.7rem",
          }}
          alt=""
        /> */}

        <img
          onClick={() => {
            if (isOnline) {
              setIsLocked(true);
            } else {
              errorMessage("Sync Failed", "Please check your network connection and try again");
            }
          }}
          src={LockIcon}
          style={{ height: "3vh", cursor: "pointer", marginRight: "0.7rem" }}
        />

        <div
          style={{
            display: "flex",
            alignItems: "end",
            justifyContent: "center",
            padding: "0.5vw",
            border: "1px solid #3C424B",
            borderRadius: "50%",
          }}
        >
          <img src={userIcon} style={{ height: "2.7vh" }} />
        </div>
        <div
          style={{
            marginLeft: "1vw",
            display: "flex",
            flexDirection: "column",
            flex: "0 1 auto",
            minWidth: 0,
          }}
        >
          <span
            title={userData?.user}
            style={{
              color: themeJSON.orderNoTextColor || "#0F0718",
              fontSize: "1em",
              fontFamily: "Inter",
              fontWeight: "500",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {userData?.user}
          </span>
          <span
            title={`Till ID : ${useAuthStore.getState().tillValue?.name}`}
            style={{
              color: themeJSON.orderNoTextColor || "#0F0718",
              fontSize: "0.8em",
              fontFamily: "Inter",
              fontWeight: "500",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            Till ID : {useAuthStore.getState().tillValue?.name}
          </span>
        </div>
        <div style={{ marginLeft: "3%" }}>
          <img
            src={Online}
            style={{
              display: !isOnline && "none",
              height: "2.5vh",
              cursor: "pointer",
              paddingBottom: "0.5vh",
            }}
          />{" "}
          <img
            src={Ofline}
            style={{
              display: isOnline && "none",
              height: "2.5vh",
              cursor: "pointer",
              paddingBottom: "0.5vh",
            }}
          />{" "}
        </div>
      </Col>
    </Row>
  );
};

export default SMHeader;
